import { GitHub, Instagram, LinkedIn, MailOutlined } from '@mui/icons-material';
import { Link, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/system';
import { HashLink } from 'react-router-hash-link';

const FooterBox = styled((props) => (
    <Box component="footer" {...props} />
))(({ theme }) => ({
    position: "relative",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-evenly",
    background: "linear-gradient(to bottom, #D2E2FD 0%, #B9CFFD 100%)",
    padding: theme.spacing(6, "4vw", 2, "4vw"),
}));

const FooterLink = styled((props) => (
    <Link {...props} />
))(({ theme }) => ({
    flexShrink: 0,
    textDecoration: "none",
    color: "inherit",
    display: "flex",
    alignItems: "center",
    width: "fit-content",
    margin: theme.spacing(2, 0),
}));

const FooterLinkText = styled((props) => (
    <Typography {...props} />
))(({ theme }) => ({
    fontFamily: "inter",
    fontSize: "1.15rem",
    fontWeight: 500,
    lineHeight: 1.2,
    display: "flex",
    alignItems: "center",
    position: "relative",
    "&::after": {
        content: "''",
        position: "absolute",
        width: "100%",
        transform: "scaleX(0)",
        height: 2,
        bottom: -2,
        left: 0,
        backgroundColor: "purple",
        transformOrigin: "bottom right",
        transition: "transform 0.25s ease-out",
    },
    "&:hover": {
        "&::after": {
            transform: "scaleX(1)",
            transformOrigin: "bottom left",
        },
    },
    [theme.breakpoints.up("lg")]: {
        fontSize: "1.2rem",
    },
}));

const FooterColumn = styled(Box)(
    ({ theme }) => ({
        flexShrink: 0,
        width: "100%",
        marginBottom: theme.spacing(3),
        [theme.breakpoints.up("sm")]: {
            width: "fit-content",
        },
    })
);

const FooterColumnTitle = styled(Typography)(
    ({ theme }) => ({
        fontFamily: "Inter",
        fontWeight: 700,
        fontSize: "1.5rem",
        marginBottom: theme.spacing(1),
        [theme.breakpoints.up("lg")]: {
            fontSize: "1.6rem",
        },
    })
);

export default function Footer(props) {
    return (
        <FooterBox>
            <FooterColumn>
                <FooterColumnTitle>
                    WHY LOCEDGE?
                </FooterColumnTitle>
                <FooterLink component={HashLink}  to="/about#eval">
                    <FooterLinkText>
                        LocEdge vs. MaxMind
                    </FooterLinkText>
                </FooterLink>
                <FooterLink component={HashLink}  to="/about#eval">
                    <FooterLinkText>
                        LocEdge vs. IP2Location
                    </FooterLinkText>
                </FooterLink>
                <FooterLink component={HashLink}  to="/about#eval">
                    <FooterLinkText>
                        LocEdge vs. HoiHo
                    </FooterLinkText>
                </FooterLink>
                <FooterLink href="https://www.youtube.com/watch?v=KJSj_DCQ1bI&t=1s" target="_blank" rel="noreferrer noopener">
                    <FooterLinkText>
                        Watch the Demo
                    </FooterLinkText>
                </FooterLink>
            </FooterColumn>
            <FooterColumn>
                <FooterColumnTitle>
                    RESOURCES
                </FooterColumnTitle>
                <FooterLink component={HashLink}  to="/About#cite">
                    <FooterLinkText>How to Cite</FooterLinkText>
                </FooterLink>
                <FooterLink href="https://raw.githubusercontent.com/ruh010/locedge-db/master/ruleset.json" target="_blank" rel="noreferrer noopener">
                    <FooterLinkText>Ruleset</FooterLinkText>
                </FooterLink>
                <FooterLink href="https://github.com/ruh010/locedge/tree/master/data/pops" target="_blank" rel="noreferrer noopener">
                    <FooterLinkText>Dataset</FooterLinkText>
                </FooterLink>
                <FooterLink href="https://www.npmjs.com/package/locedge" target="_blank" rel="noreferrer noopener">
                    <FooterLinkText>Node Package</FooterLinkText>
                </FooterLink>
                <FooterLink href="#">
                    <FooterLinkText>Browser Extensions</FooterLinkText>
                </FooterLink>
            </FooterColumn>
            <FooterColumn>
                <FooterColumnTitle>
                    ADDITIONAL
                </FooterColumnTitle>
                <FooterLink component={HashLink} to="/about#overview">
                    <FooterLinkText>
                        Motivation
                    </FooterLinkText>
                </FooterLink>
                <FooterLink component={HashLink} to="/about#methodology">
                    <FooterLinkText>
                        How to Identify GeoHints
                    </FooterLinkText>
                </FooterLink>
                <FooterColumnTitle sx={{ marginTop: 3 }}>
                    CREDITS
                </FooterColumnTitle>
                <FooterLink component={HashLink} to="/about">
                    <FooterLinkText>
                        Credits
                    </FooterLinkText>
                </FooterLink>
            </FooterColumn>
            <FooterColumn sx={{
                display: { xs: "flex", sm: "block" },
                width: { xs: "18rem", sm: "fit-content" },
                marginRight: { xs: "auto", sm: 0 },
                justifyContent: "space-between",
                marginTop: { xs: -3, sm: 0 },
                marginBottom: { xs: 0, sm: 3 },
            }}>
                <FooterLink href="mailto:itsrunhuang@outlook.com" sx={{ marginY: 2 }}>
                    <MailOutlined />
                </FooterLink>
                <FooterLink href="https://www.instagram.com/run.huang208/" sx={{ marginY: 2 }}>
                    <Instagram />
                </FooterLink>
                <FooterLink href="www.linkedin.com/in/runhuangii" sx={{ marginY: 2 }}>
                    <LinkedIn />
                </FooterLink>
                <FooterLink href="https://github.com/ruh010" sx={{ marginY: 2 }}>
                    <GitHub />
                </FooterLink>
            </FooterColumn>
        </FooterBox >
    );
};